import { render, staticRenderFns } from "./noPendingTasks.vue?vue&type=template&id=6a98bb2e&scoped=true&"
var script = {}
import style0 from "./noPendingTasks.vue?vue&type=style&index=0&id=6a98bb2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a98bb2e",
  null
  
)

export default component.exports